export default __webpack_public_path__ + "static/media/complete_icon@2x.678c00b4.png";